import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core'

@Component({
    selector: 'app-canvas-grid',
    templateUrl: './canvas-grid.component.html',
    styleUrls: ['./canvas-grid.component.css'],
})
export class CanvasGridComponent implements OnInit {
    @ViewChild('canvas') canvas

    @Input() space = 100
    @Input() strokeColor = '#b5b5b5'
    @Input() strokeWidth = 2
    @Input() lineDash = [5, 5]

    constructor(private el: ElementRef) {
    }

    ngOnInit() {
        this.drawGrid()
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.drawGrid()
    }

    drawGrid() {
        const space = this.space
        const canvas = this.canvas.nativeElement
        canvas.width = canvas.offsetWidth
        canvas.height = canvas.offsetHeight
        const bw = canvas.width
        const bh = canvas.height
        // setTimeout(() => {
        const context = canvas.getContext('2d')
        context.clearRect(0, 0, context.canvas.width, context.canvas.height)
        const totalX = Math.floor(bw / (space + 1))
        const totalY = Math.floor(bh / (space + 1))
        let dX = (bw - (space + 1) * totalX) / 2
        let dY = (bh - (space + 1) * totalY) / 2

        // vertical line
        for (let x = dX; x <= bw; x += space) {
            context.setLineDash(this.lineDash)
            context.moveTo(x, 0)
            context.lineTo(x, bh)
        }

        // horizontal line
        for (let y = dY; y <= bh; y += space) {
            context.setLineDash(this.lineDash)
            context.moveTo(0, y)
            context.lineTo(bw, y)
        }

        context.lineWidth = this.strokeWidth
        context.strokeStyle = this.strokeColor
        context.stroke()
        // }, 200);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/canvas-grid/canvas-grid.component.ts